module.exports = __webpack_public_path__ + "media/entities/1013-41564fb4.png";